<ng-template #errorContainer></ng-template>
<div class="app">
  <router-outlet></router-outlet>
</div>
